import { combineReducers } from 'redux'
// import todos from './todos'
import appstate from './appstate'
import login from './login'
import quiz from './quiz'
// import visibilityFilter from './visibilityFilter'

export default combineReducers({
  appstate,
  login,
  quiz
})


// WEBPACK FOOTER //
// ./src/components/store/reducers/index.js